import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ c("path", { d: "M15.53 7.315 9.02.815a1.46 1.46 0 0 0-2.05 0l-6.5 6.5A.751.751 0 0 0 1 8.595h.65v5.56c0 .8.65 1.45 1.45 1.45h2.38c.41 0 .75-.34.75-.75v-1.97c0-.95.79-1.72 1.77-1.72s1.77.77 1.77 1.72v1.97c0 .41.34.75.75.75h2.38c.8 0 1.45-.65 1.45-1.45v-5.56H15c.3 0 .58-.18.69-.46.12-.28.05-.6-.16-.82Z" }, null, -1), r = [
  n
];
function s(h, l) {
  return e(), t("svg", o, [...r]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
